import React from "react";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="container navbar-offset">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <h1 className="display-4 fw-bold mb-3 text-primary PrivacyPolicy-heading-h1">
            Privacy Policy
          </h1>
          <p className="text-muted small mb-4">Last updated: April 09, 2025</p>

          <p className="mb-4 PrivacyPolicy-paragraph">
            At <strong>LankaLearners.lk</strong>, your privacy is important to
            us. This Privacy Policy outlines how we collect, use, and safeguard
            your information when you use our website and services.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 PrivacyPolicy-heading-h2">
            1. Information We Do Not Collect
          </h2>
          <p className="mb-4 PrivacyPolicy-paragraph">
            LankaLearners.lk is an open-access educational platform. We do not
            require users to register or submit personal information such as
            names, email addresses, or phone numbers.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 PrivacyPolicy-heading-h2">
            2. Analytics and Cookies
          </h2>
          <p className="mb-4 PrivacyPolicy-paragraph">
            We may use cookies or third-party analytics tools such as Google
            Analytics to improve site performance and user experience. These
            tools collect anonymized traffic data and usage behavior.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 PrivacyPolicy-heading-h2">
            3. External Links
          </h2>
          <p className="mb-4 PrivacyPolicy-paragraph">
            LankaLearners.lk may link to external sites such as the Department
            of Motor Traffic (DMT) or app stores. We are not responsible for the
            privacy practices or content of these third-party websites.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 PrivacyPolicy-heading-h2">
            4. Children’s Privacy
          </h2>
          <p className="mb-4 PrivacyPolicy-paragraph">
            LankaLearners.lk is suitable for users of all ages. We do not
            knowingly collect data from children.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 PrivacyPolicy-heading-h2">
            5. Data Security
          </h2>
          <p className="mb-4 PrivacyPolicy-paragraph">
            We implement industry-standard security practices to maintain the
            safety of your browsing experience. However, no method of data
            transmission or storage over the internet is 100% secure.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 PrivacyPolicy-heading-h2">
            6. Updates to This Policy
          </h2>
          <p className="mb-4 PrivacyPolicy-paragraph">
            We may revise this Privacy Policy from time to time. Any changes
            will be posted on this page with the updated date.
          </p>

          <h2 className="h4 fw-semibold mt-5 mb-2 PrivacyPolicy-heading-h2">
            7. Contact Us
          </h2>
          <p className="mb-2 PrivacyPolicy-paragraph">
            If you have questions about this Privacy Policy, please contact us:
          </p>
          <ul className="list-unstyled ms-3 mb-4 PrivacyPolicy-paragraph">
            <li className="mb-1">
              📧 Email:{" "}
              <a
                href="mailto:lankalearners59@gmail.com"
                className="text-decoration-underline text-primary"
              >
                lankalearners59@gmail.com
              </a>
            </li>
            <li className="mb-1">
              📞 Phone:{" "}
              <a
                href="tel:+94765747783"
                className="text-decoration-underline text-primary"
              >
                +94 76 574 7783
              </a>
            </li>
            <li className="mb-1">
              🌐 Website:{" "}
              <a
                href="https://lankalearners.lk/contact-lanka-learners"
                className="text-decoration-underline text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://lankalearners.lk/contact-lanka-learners
              </a>
            </li>
          </ul>

          <p className="text-muted small">
            This policy applies only to information collected through our
            website and not to information collected offline.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
